import { render } from "./Footer.vue?vue&type=template&id=297f8dda&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=297f8dda&scoped=true&lang=css"

import exportComponent from "/Users/pkraeutli/development/reca/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297f8dda"]])

export default __exports__